import * as R from 'ramda'

const hasCapitalLetter = a => /[A-Z]/.test(a)

const isNotEmpty = R.compose(
  R.not,
  R.isEmpty,
)

const isNotEmptyString = a => {
  if (R.is(String, a)) {
    return R.is(String, a) ? a.trim().length > 0 : false
  } else if (R.is(Number, a)) {
    a = a.toString()
    return a.trim().length > 0
  } else {
    return false
  }
}

const isLengthGreaterThan = len => R.compose(
  R.gt(len),
  R.prop('length')
)

const isNotNil = R.compose(
  R.not,
  R.isNil
)
const isGreaterThan = val =>  R.compose(
  R.not,
  R.gt(val)
)

const isLessThan = val => R.compose(
  R.not,
  R.lt(val)
)

const isGreaterThanOrNil = val => R.compose(
  R.either(
    isGreaterThan(val),
    isEmptyOrNil
  )
)

const isLessThanOrNil = val => R.compose(
  R.either(
    isLessThan(val),
    isEmptyOrNil
  )
)

const betweenOrNil = (min, max) => R.compose(
  R.either(
    between(min, max),
    isEmptyOrNil
  )
)

const isNot = R.compose(
  R.not,
  R.is
)

const isEmptyOrNil = R.compose(
  R.either(
    R.isNil,
    R.isEmpty
  )
)

const isNotEmptyOrNil = R.compose(
  R.not,
  R.either(
    R.isNil,
    R.isEmpty
  )
)

const matchDecimal = R.curry(
  (decimalNum, value) => {
    const valueStr = value ? String(value) : ''
    const innerStr = decimalNum > 0
      ? `(\\.?[0-9]{0,${decimalNum}})?`
      : ''
    return valueStr.match(new RegExp(`^-?[0-9]*${innerStr}$`))
  }
)

const between = R.curry((min, max) => R.both(
  R.lte(min),
  R.gte(max)
))

const notBetween = R.curry((min, max) => R.both(
  R.not,
  R.lt(min),
  R.gt(max)
))

const isSubset = R.compose(
  R.isEmpty,
  R.without
)

const reduceWithIndex = R.addIndex(R.reduce)

const isLowercase = R.test(/^([a-z])+$/g)
const isUppercase = R.test(/([A-Z])+/g)
const isNumber = R.test(/^([0-9])+$/g)
const isHex = R.test(/^[a-fA-F0-9]*$/g)

export default {
  reduceWithIndex,
  between,
  isNot,
  isNotNil,
  isNotEmpty,
  isNotEmptyString,
  isNotEmptyOrNil,
  hasCapitalLetter,
  isLengthGreaterThan,
  matchDecimal,
  isSubset,
  isLowercase,
  isUppercase,
  isNumber,
  isHex,
  isGreaterThan,
  isLessThan,
  notBetween,
  isGreaterThanOrNil,
  isLessThanOrNil,
  betweenOrNil
}
